export default "__VITE_ASSET__2d415afc__"